import { AfterViewChecked, Component, Input, ViewChild } from '@angular/core';
import { ElementBase } from "../element-base";
import { DropdownInputComponent } from "../../../../../shared/dropdown-input/dropdown-input.component";

@Component({
  selector: 'app-element-dropdown',
  templateUrl: './element-dropdown.component.html',
  styleUrl: './element-dropdown.component.scss'
})
export class ElementDropdownComponent extends ElementBase implements AfterViewChecked {
  @Input() showCompletionWarning: boolean = false;
  @ViewChild('dropdown') dropdown: DropdownInputComponent;

  protected dropdownOptions: {value: string, text: string}[] = [];

  ngAfterViewChecked(): void {
    this.dropdownOptions = this.element.options.map(o => ({value: o.id, text: o.text}));
    this.dropdown.setPlaceholder();
  }
}
